import React from "react";
import Icon, { type IconProps } from "./Icon";

/**
 * Info icon — vendored from Lucide.
 * Source: https://lucide.dev/icons/info (MIT). Copied 2026-05-16.
 *
 * First icon migrated as part of Phase 2 Atoms: replaces the `ⓘ` Unicode
 * glyph in `src/components/ui/Tooltip.tsx`'s InfoIcon. Same visual role,
 * proper currentColor + sizing, theme-agnostic.
 */
export default function Info(props: Omit<IconProps, "children">) {
  return (
    <Icon {...props}>
      <circle cx="12" cy="12" r="10" />
      <path d="M12 16v-4" />
      <path d="M12 8h.01" />
    </Icon>
  );
}
